import { Heading, Text } from '@ksyos/design-system';

export function RequireMfa() {
    return (
        <>
            <Heading>Geen tweestapsverificatie ingesteld</Heading>
            <Text>
                Stuur een mail naar <b>info@ksyos.nl</b>.
                <br />
                <br />
                Mail ons vanaf het e-mailadres dat gekoppeld is aan jouw Ksyos account en vermeld je naam en de
                organisatie(s) waar je werkt. Binnen 4 uur (op werkdagen) ontvang je een activatiemail die 24 uur geldig
                is.
            </Text>
            <img
                alt="Require MFA"
                src="/assets/images/no-access-2FA.svg"
            />
        </>
    );
}
